import * as yup from 'yup';
import {formData} from './LeadGenerationForm.type';
import {isValidPhoneNumber} from '@utils/validation.utils';
import {getCountryCodeAndNameFromValue} from '@services/properties/getLeadGenerationOptions';

export const FORM_DATA_INITIAL_VALUES: formData = {
  firstName: '',
  lastName: '',
  countryCode: '+971___United Arab Emirates',
  contact: '',
  email: '',
  country: 'United Arab Emirates',
  city: '',
  nationality: '',
  language: '',
  goldenVisa: false,
  isCallbackNeeded: false,
  consent: false,
  otherPropertyUpdates: false,
  aldarUpdates: false,
};

export const validationSchema = yup.object({
  firstName: yup
    .string()
    .required('First name is required')
    .max(35, 'First name should be 35 characters long')
    .matches(/^[A-Za-z\s]+$/, 'First name should contain only letters'),
  lastName: yup
    .string()
    .required('Last name is required')
    .max(35, 'Last name should be 35 characters long')
    .matches(
      /^[A-Za-z\s]+$/,
      'Last name should contain only letters and spaces'
    ),
  email: yup
    .string()
    .required('Email is required')
    .email('Invalid email format'),
  countryCode: yup.string().when('isCallbackNeeded', {
    is: true,
    then: (schema) => schema.required('Country code is required'),
  }),
  contact: yup
    .string()
    .required('Phone number is required')
    .test(
      'Phone Number Validity Check',
      'Not a valid phone number',
      function (number) {
        const {code} = getCountryCodeAndNameFromValue(this.parent.countryCode);
        return isValidPhoneNumber(number, code);
      }
    ),
  country: yup.string().when('isCallbackNeeded', {
    is: true,
    then: (schema) => schema.required('Country of residence is required'),
  }),
  city: yup.string().ensure(),
  // .when('country', (country, schema) => {
  //   return country[0] === 'United Arab Emirates'
  //     ? schema.required('City is required')
  //     : schema;
  // })
  nationality: yup.string().when('isCallbackNeeded', {
    is: true,
    then: (schema) => schema.required('Nationality is required'),
  }),
  language: yup.string().when('isCallbackNeeded', {
    is: true,
    then: (schema) => schema.required('Language is required'),
  }),
  isCallbackNeeded: yup.boolean(),
  goldenVisa: yup.boolean(),
  otherPropertyUpdates: yup.boolean().required(),
  aldarUpdates: yup.boolean().required(),
  consent: yup.boolean().required(),
});

export const DATE_TIME_FORMATE = 'yyy-MM-dd hh:mm:ss';
export const LEAD_GENERATION_FORM_TYPE = {
  community: 2,
  property: 1,
};

export const REQUEST_FAILED_ERROR_MESSAGE =
  'Failed to register interest and view/download brochure. Please check the information provided and try again. Error: View Brochure Request Failed.';
